// src/pages/hotelRatings/HotelRatings.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import HotelRatingsTable from "../../components/hotelRatings/HotelRatingsTable";

const HotelRatings = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Hotel Ratings */}
            <HotelRatingsTable />
        </WrapperSection>
    );
};

export default HotelRatings;
